
<template>
  <div class="main_content">
    <router-view></router-view>
    <div class="footer">
        北京中数智汇科技股份有限公司出品
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {

      }
    },
    methods:{

    },
    ready:function(){

    }
  }
</script>

<style type="text/css">
.main_content{
    position: relative;
}

</style>



// WEBPACK FOOTER //
// App.vue?38a05374